import { ComponentsTransfer } from "./ComponentsTransfer"
import { ChemicalComponent } from "@/services/chemical-component"
import { useRequest } from "ahooks"
import { PropertySetModule } from "@/services/admin/property-set/modal"
import { useOutletContext } from "react-router-dom"
import { Button, Space } from "antd"
import { useState } from "react"


export function PropertySetComponents() {
  const {propertySet, onSave, onCancel, orgId} = useOutletContext<{propertySet: PropertySetModule.Modal, onSave: (values) => Promise<void>, onCancel: () => void, orgId?: number}>();
  const { data = [] } = useRequest(() => {
    if (orgId) {
      return ChemicalComponent.OrganizationService.get(orgId, {})
    }
    return ChemicalComponent.AdminService.get({})
  }, {
    refreshDeps: [orgId]
  })
  const [value, setValue] = useState(propertySet?.components?.map(item => item.id) || [] as number[]);
  const onChange = (keys: number[]) => {
    setValue(keys)
  }

  const saveComponents = () => {
    onSave({...propertySet, components: value})
  }

  return <div>
    <ComponentsTransfer
      dataSource={data}
      value={value}
      onChange={onChange}
    />
    <div className="flex-end mt-2">
        <Space>
          <Button type="default" onClick={onCancel}>Cancel</Button>
          <Button type="primary" onClick={saveComponents}>Save</Button>
        </Space>
      </div>
  </div>
}